<section class="section profile">
  <div class="row">
    <div class="col-xl-8">
      <div class="card">
        <div class="card-body pt-3">
          <!-- Bordered Tabs -->
          <ul class="nav nav-tabs nav-tabs-bordered" role="tablist">
            <li class="nav-item" role="presentation">
              <button (click)="SelectedTabIndex = 1" class="nav-link" [ngClass]="{ active: SelectedTabIndex === 1 }">Overview</button>
            </li>

            <li class="nav-item" role="presentation">
              <button (click)="SelectedTabIndex = 2" class="nav-link" [ngClass]="{ active: SelectedTabIndex === 2 }">Edit Profile</button>
            </li>

            <li (click)="SelectedTabIndex = 3" class="nav-item" role="presentation">
              <button class="nav-link" [ngClass]="{ active: SelectedTabIndex === 3 }">Change Password</button>
            </li>
          </ul>
          <div class="tab-content pt-2">
            <div class="tab-pane fade profile-overview" id="profile-overview" [ngClass]="{ 'active show': SelectedTabIndex === 1 }">
              <div class="text-start my-3">
                <h4>{{ UserDetails.firstName }} {{ UserDetails.lastName }}</h4>
                <h6>{{ UserDetails.title }}</h6>
              </div>
              <hr />

              <h5 class="card-title pt-0 pb-4">Profile Details</h5>

              <div class="row">
                <div class="col-lg-3 col-md-4 label">Full Name</div>
                <div class="col-lg-9 col-md-8">{{ UserDetails.firstName }} {{ UserDetails.lastName }}</div>
              </div>

              <div class="row">
                <div class="col-lg-3 col-md-4 label">Clinic</div>
                <div class="col-lg-9 col-md-8">
                  {{ apiService.GetClinicName(UserDetails.clinicId) }}
                </div>
              </div>

              <div class="row">
                <div class="col-lg-3 col-md-4 label">Title</div>
                <div class="col-lg-9 col-md-8">{{ UserDetails.title || 'No Title' }}</div>
              </div>

              <div class="row">
                <div class="col-lg-3 col-md-4 label">Phone</div>
                <div class="col-lg-9 col-md-8">
                  {{ UserDetails.phoneNumber | phonenumber : 'format' }}
                </div>
              </div>

              <div class="row">
                <div class="col-lg-3 col-md-4 label">Email</div>
                <div class="col-lg-9 col-md-8">{{ UserDetails.email }}</div>
              </div>
              <div class="row">
                <div class="col-lg-3 col-md-4 label">Role</div>
                <div class="col-lg-9 col-md-8">
                  {{ UserDetails.roleId === 1 ? 'Admin' : 'Employee' }}
                </div>
              </div>
            </div>

            <div class="tab-pane fade profile-edit pt-3" [ngClass]="{ 'active show': SelectedTabIndex === 2 }" id="profile-edit">
              <!-- Profile Edit Form -->
              <form class="row g-3" (ngSubmit)="UpdateEmployee()" [formGroup]="EditProfileForm">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="fName">First Name</label>
                    <div
                      class="input-group"
                      [ngClass]="{
                        'has-invalid': EditProfileForm.get('firstName')?.invalid && EditProfileForm.get('firstName')?.touched
                      }"
                    >
                      <input type="text" formControlName="firstName" class="form-control" id="fName" placeholder="First Name" />
                      <span class="error-message" *ngIf="EditProfileForm.get('firstName')?.errors?.['required'] && EditProfileForm.get('firstName')?.touched"> This is required field </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="lname">Last Name</label>
                    <div
                      class="input-group"
                      [ngClass]="{
                        'has-invalid': EditProfileForm.get('lastName')?.invalid && EditProfileForm.get('lastName')?.touched
                      }"
                    >
                      <input type="text" formControlName="lastName" class="form-control" id="lname" placeholder="Last Name" />
                      <span class="error-message" *ngIf="EditProfileForm.get('lastName')?.errors?.['required'] && EditProfileForm.get('lastName')?.touched"> This is required field </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="phone">Phone number</label>
                    <div
                      class="input-group"
                      [ngClass]="{
                        'has-invalid': EditProfileForm.get('phoneNumber')?.invalid && EditProfileForm.get('phoneNumber')?.touched
                      }"
                    >
                      <input
                        type="text"
                        (keydown)="sharedService.validateNumber($event)"
                        [value]="EditProfileForm.get('phoneNumber')?.value | phonenumber : 'format'"
                        formControlName="phoneNumber"
                        class="form-control"
                        [maxlength]="MaxPhoneLength"
                        id="phone"
                        placeholder="Phone number"
                      />
                      <span class="error-message" *ngIf="EditProfileForm.get('phoneNumber')?.errors?.['required'] && EditProfileForm.get('phoneNumber')?.touched"> This is required field </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 align-self-end">
                  <button type="submit" [disabled]="EditProfileForm.invalid" class="btn btn-primary">Update</button>
                </div>
              </form>

              <!-- End Profile Edit Form -->
            </div>

            <div class="tab-pane fade pt-3" [ngClass]="{ 'active show': SelectedTabIndex === 3 }" id="profile-change-password">
              <!-- Change Password Form -->
              <div class="text-end">
                <button class="btn btn-sm btn-link" type="button" tabindex="-1" (click)="ShowPasswords = !ShowPasswords">{{ ShowPasswords ? 'Hide' : 'Show' }} Passwords</button>
              </div>
              <form (ngSubmit)="ChangePassword()" [formGroup]="PasswordForm">
                <div class="row mb-3">
                  <label for="currentPassword" class="col-md-4 col-lg-3 col-form-label">Current Password</label>
                  <div class="col-md-8 col-lg-9">
                    <div class="form-group">
                      <div
                        class="input-group"
                        [ngClass]="{
                          'has-invalid': PasswordForm.get('oldPassword')?.invalid && PasswordForm.get('oldPassword')?.touched
                        }"
                      >
                        <input name="oldPassword" type="{{ ShowPasswords ? 'text' : 'password' }}" class="form-control" id="currentPassword" formControlName="oldPassword" />
                        <span class="error-message" *ngIf="PasswordForm.get('oldPassword')?.errors?.['required'] && PasswordForm.get('oldPassword')?.touched"> This is required field </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mb-3">
                  <label for="newPassword" class="col-md-4 col-lg-3 col-form-label">New Password</label>
                  <div class="col-md-8 col-lg-9">
                    <div class="form-group">
                      <div
                        class="input-group"
                        [ngClass]="{
                          'has-invalid': PasswordForm.get('newPassword')?.invalid && PasswordForm.get('newPassword')?.touched
                        }"
                      >
                        <input name="newpassword" type="{{ ShowPasswords ? 'text' : 'password' }}" class="form-control" id="newPassword" formControlName="newPassword" />
                        <ul class="error-message ps-3 mt-1" *ngIf="PasswordForm.get('newPassword')?.invalid && PasswordForm.get('newPassword')?.dirty && PasswordForm.get('newPassword')?.touched">
                          <li *ngIf="PasswordForm.get('newPassword')?.errors?.['required']">Password is required.</li>
                          <li *ngIf="PasswordForm.get('newPassword')?.errors?.['minlength']">Password must be at least 8 characters long.</li>
                          <li *ngIf="PasswordForm.get('newPassword')?.errors?.['maxlength']">Password must not exceed 16 characters.</li>
                          <li *ngIf="PasswordForm.get('newPassword')?.errors?.['uppercase']">Password must contain at least one uppercase letter.</li>
                          <li *ngIf="PasswordForm.get('newPassword')?.errors?.['lowercase']">Password must contain at least one lowercase letter.</li>
                          <li *ngIf="PasswordForm.get('newPassword')?.errors?.['number']">Password must contain at least one number.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mb-3">
                  <label for="renewPassword" class="col-md-4 col-lg-3 col-form-label">Re-enter New Password</label>
                  <div class="col-md-8 col-lg-9">
                    <input name="renewpassword" type="{{ ShowPasswords ? 'text' : 'password' }}" class="form-control" id="renewPassword" formControlName="confirmPassword" />
                  </div>
                </div>

                <div class="text-end">
                  <button type="submit" [disabled]="PasswordForm.invalid" class="btn btn-primary">Change Password</button>
                </div>
              </form>
              <!-- End Change Password Form -->
            </div>
          </div>
          <!-- End Bordered Tabs -->
        </div>
      </div>
    </div>
  </div>
</section>
